import { Action, createReducer, on } from '@ngrx/store';

import { AdminAlertsState } from '../types';
import { setAdminAlertsItems } from './actions';

const initialState: AdminAlertsState = { items: [] };

const reducer = createReducer(
  initialState,
  on(setAdminAlertsItems, (state: AdminAlertsState, { payload }) => ({
    ...state,
    items: payload,
  })),
);

export function adminAlertsReducer(state: AdminAlertsState, action: Action): AdminAlertsState {
  return reducer(state, action);
}
